// NEDERLANDS — vertaling voor uw gemak. De Franse versie is de enige die geldt (zie fr.js).

import { COURRIEL, TELEPHONE, adresseVendeur, encadreIdentite } from './identite';

const ADRESSE = adresseVendeur('België');
const TRADUCTION =
  'Deze vertaling wordt aangeboden voor uw gemak. Bij enig verschil is uitsluitend de Franse versie rechtsgeldig.';

export default {
  cgv: {
    seoTitre: 'Algemene Verkoopvoorwaarden',
    seoDescription:
      'Algemene verkoopvoorwaarden van MirumGames: bestellen, prijzen, betaling, herroepingsrecht van 14 dagen, levering en garanties.',
    titre: 'Algemene Verkoopvoorwaarden',
    maj: 'Laatst bijgewerkt: 23/09/2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Artikel 1: Algemeen',
        blocs: [
          { p: 'Elke bestelling op MIRUMGAMES.COM houdt de voorafgaande aanvaarding van deze algemene voorwaarden in. De klant erkent de inhoud ervan zonder voorbehoud te hebben gelezen en aanvaard.' },
        ],
      },
      {
        titre: 'Artikel 2: Voorwerp',
        blocs: [
          { p: 'Deze algemene voorwaarden bepalen de rechten en plichten van de partijen bij de onlineverkoop van de producten en diensten die MirumGames.com aan de consument aanbiedt.' },
        ],
      },
      {
        titre: 'Artikel 3: Prijzen en Betaling',
        blocs: [
          { p: 'De prijzen zijn in euro en inclusief de toepasselijke btw. Verzendkosten zijn niet inbegrepen en worden apart aangerekend. De volledige betaling gebeurt op het ogenblik dat de bestelling wordt bevestigd.' },
          { p: 'MirumGames.com aanvaardt kaartbetalingen via STRIPE, een gecertificeerde en beveiligde betaaldienstverlener.' },
          { p: 'Voor elke betaalde bestelling wordt een factuur op naam van de koper opgemaakt. U vindt ze op de bevestigingspagina van de bestelling, via de link in de bevestigingsmail en, als u een account hebt, onder „Mijn bestellingen”. Stripe stuurt daarnaast een betalingsbewijs per e-mail.' },
        ],
      },
      {
        titre: 'Artikel 4: Herroepingsrecht',
        blocs: [
          { p: 'Elke particuliere consument beschikt over 14 dagen om producten terug te sturen die niet voldoen. Deze termijn begint op de dag van de levering.' },
          { p: 'Voorwaarden voor retour:' },
          {
            liste: [
              'De producten moeten worden teruggestuurd in hun oorspronkelijke verpakking, in perfect verkoopbare staat',
              'Producten met gebruikssporen worden niet aanvaard',
              'De retourkosten zijn ten laste van de consument',
              'De terugbetaling gebeurt per overschrijving binnen 15 dagen',
            ],
          },
        ],
      },
      {
        titre: 'Artikel 5: Commerciële Garantie',
        blocs: [
          { p: 'MirumGames.com waarborgt de producten tegen verborgen gebreken overeenkomstig de Belgische wetgeving. MirumGames.com is niet de fabrikant van de aangeboden artikelen en wijst elke aansprakelijkheid af voor schade veroorzaakt door een productgebrek.' },
          { p: 'De aansprakelijkheid van de verkoper is beperkt tot het omruilen of terugbetalen van het gebrekkige product.' },
        ],
      },
      {
        titre: 'Artikel 6: Beschikbaarheid van de Producten',
        blocs: [
          { p: 'De aanbiedingen gelden zolang de voorraad strekt. Afbeeldingen, kleuren, afmetingen en gewichten zijn louter informatief en niet contractueel. MirumGames.com wijst elke aansprakelijkheid af voor afwijkingen in de producteigenschappen.' },
        ],
      },
      {
        titre: 'Artikel 7: Levering',
        blocs: [
          { p: 'De producten worden geleverd op het adres dat de consument op het bestelformulier heeft opgegeven. Dat moet een fysiek adres zijn (geen postbus).' },
          { p: 'Wij verzenden naar België, Frankrijk, Luxemburg, Nederland, Duitsland en Spanje. Gemiddelde levertijden:' },
          {
            liste: [
              'Luxemburg, België, Nederland: 1 tot 2 werkdagen',
              'Frankrijk, Duitsland: 2 tot 4 werkdagen',
              'Spanje: 4 tot 5 werkdagen',
            ],
          },
          { p: 'Let op: de verwerkingstijd (gemiddeld 1 werkdag) komt daar nog bij.' },
        ],
      },
      {
        titre: 'Artikel 8: Overeenstemming van de Levering',
        blocs: [
          { p: 'Bij ontvangst controleert de consument of de producten overeenstemmen met de bestelbon. Elk gebrek moet handgeschreven op de leveringsbon worden vermeld.' },
          { p: 'Elke afwijking (ontbrekend of beschadigd product, enz.) moet binnen 96 uur na de verzendbevestiging aan MirumGames.com worden gemeld.' },
        ],
      },
      {
        titre: 'Artikel 9: Aansprakelijkheid',
        blocs: [
          { p: 'MirumGames.com kan niet aansprakelijk worden gesteld voor schade door verkeerd gebruik of onzorgvuldige behandeling van de producten na de levering.' },
        ],
      },
      {
        titre: 'Artikel 10: Toepasselijk Recht',
        blocs: [
          { p: 'Deze algemene voorwaarden worden beheerst door het Belgische recht. Bij een geschil wordt de consument verzocht eerst contact op te nemen met MirumGames.com om tot een minnelijke oplossing te komen.' },
        ],
      },
      {
        titre: 'Wettelijke Vermeldingen',
        blocs: [
          { p: 'De volledige wettelijke gegevens van de onderneming (contactgegevens, btw-nummer, enz.) vindt u op onze <a href="/legal" class="text-blue-600 hover:text-blue-800 underline">pagina Wettelijke Vermeldingen</a>.' },
          { p: 'Voor bestellingen waarvan de betaling tot en met 22/09/2026 (Belgische tijd) werd ontvangen, is Charlotte Ansiaux (KBO 1000.107.018) de verkoper, en dat blijft ze; voor bestellingen waarvan de betaling vanaf 23/09/2026 wordt ontvangen, is Sébastien Schoonjans de verkoper.' },
        ],
      },
    ],
  },

  confidentialite: {
    seoTitre: 'Privacybeleid',
    seoDescription:
      'Privacybeleid van MirumGames: verzamelde gegevens, gebruik, cookies, anonieme bezoekersmeting en uw rechten onder de AVG.',
    titre: 'Privacybeleid',
    maj: 'Laatst bijgewerkt: 23/09/2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: '1. Verzameling van Persoonsgegevens',
        blocs: [
          { p: 'MirumGames.com verzamelt de persoonsgegevens die nodig zijn om:' },
          {
            liste: [
              'Uw bestelling te verwerken (naam, adres, e-mail, telefoon)',
              'U bestelbevestigingen en leveringsberichten te sturen',
              'Uw klantenaccount te beheren',
              'U onze nieuwsbrieven te sturen (met uw toestemming)',
              'Onze diensten te verbeteren',
            ],
          },
        ],
      },
      {
        titre: '2. Gebruik van de Gegevens',
        blocs: [
          { p: 'Uw gegevens worden uitsluitend gebruikt voor de hierboven vermelde doeleinden. MirumGames.com geeft uw gegevens nooit door aan derden zonder uw uitdrukkelijke toestemming.' },
          { p: 'De enige uitzonderingen zijn:' },
          {
            liste: [
              'De logistieke dienstverleners, voor de levering',
              'STRIPE, voor de verwerking van de betalingen',
              'De overheid, wanneer de wet dat vereist',
            ],
          },
        ],
      },
      {
        titre: '3. Cookies',
        blocs: [
          { p: 'MirumGames.com gebruikt cookies om uw gebruikservaring te verbeteren, met name om:' },
          {
            liste: [
              'Uw navigatievoorkeuren te onthouden',
              'Uw winkelmandje te beheren',
              'Uw ervaring te personaliseren',
            ],
          },
          { p: 'U kunt cookies op elk moment uitschakelen via de instellingen van uw browser. Dat kan echter de werking van de site beïnvloeden.' },
          { p: '<strong>Bezoekersmeting:</strong> wij gebruiken een eigen bezoekersteller, zonder cookie en zonder persoonsgegevens. Noch uw IP-adres, noch uw surfgeschiedenis wordt bewaard: er worden alleen geaggregeerde, anonieme statistieken opgesteld (paginaweergaven, aantal bezoekers per dag). Daarmee kunnen wij u niet volgen van de ene dag op de andere, noch van de ene site naar de andere, en u kunt dit op elk moment weigeren via de link „Mijn cookies beheren” onderaan de pagina.' },
        ],
      },
      {
        titre: '4. Uw Rechten (AVG)',
        blocs: [
          { p: 'Als inwoner van Europa hebt u de volgende rechten:' },
          {
            liste: [
              '<strong>Recht op inzage:</strong> u kunt inzage vragen in uw persoonsgegevens',
              '<strong>Recht op rectificatie:</strong> u kunt onjuiste gegevens laten corrigeren',
              '<strong>Recht op vergetelheid:</strong> u kunt de verwijdering van uw gegevens vragen',
              '<strong>Recht op beperking:</strong> u kunt de verwerking van uw gegevens beperken',
              '<strong>Recht op overdraagbaarheid:</strong> u kunt uw gegevens in een gestructureerd formaat ontvangen',
              '<strong>Recht van bezwaar:</strong> u kunt bezwaar maken tegen de verwerking van uw gegevens',
            ],
          },
          { p: `Om deze rechten uit te oefenen, neemt u contact op via ${COURRIEL}.` },
        ],
      },
      {
        titre: '5. Beveiliging van de Gegevens',
        blocs: [
          { p: 'MirumGames.com neemt passende technische en organisatorische beveiligingsmaatregelen om uw gegevens te beschermen:' },
          {
            liste: [
              'SSL/TLS-versleuteling van alle verbindingen',
              'Beperkte toegang tot persoonsgegevens',
              'Regelmatige back-ups van de gegevens',
              'Naleving van de AVG',
            ],
          },
        ],
      },
      {
        titre: '6. Bewaartermijn',
        blocs: [
          { p: 'Uw persoonsgegevens worden bewaard zolang dat nodig is voor:' },
          {
            liste: [
              'De uitvoering van uw bestelling en de garanties',
              'De naleving van wettelijke verplichtingen (met name fiscale)',
              'Het beheer van uw klantenaccount',
            ],
          },
          { p: 'Na die periode worden uw gegevens verwijderd of geanonimiseerd.' },
        ],
      },
      {
        titre: '7. Derden',
        blocs: [
          { p: 'MirumGames.com kan uw gegevens delen met de volgende dienstverleners:' },
          {
            liste: [
              '<strong>STRIPE</strong>: voor de verwerking van de betalingen',
              '<strong>Sendcloud</strong>: voor het beheer van verzendingen en leveringen',
              '<strong>Sentry</strong>: voor het melden van technische fouten op de site. Alleen de informatie die nodig is om een storing te diagnosticeren wordt doorgegeven; er wordt geen opname van uw navigatie gemaakt.',
              '<strong>Hosting</strong>: voor de opslag van de site en de gegevens',
            ],
          },
          { p: 'Al deze dienstverleners zijn verplicht de vertrouwelijkheid van uw gegevens te respecteren.' },
        ],
      },
      {
        titre: '8. Contact',
        blocs: [
          { p: 'Voor elke vraag over uw privacy neemt u contact op met:' },
          { p: `<strong>Verwerkingsverantwoordelijke:</strong> Sébastien Schoonjans (MirumGames.com)<br /><strong>E-mail:</strong> ${COURRIEL}<br /><strong>Adres:</strong> ${ADRESSE}` },
          { p: 'De gegevens van de bestaande klantenaccounts werden op 23/09/2026 samen met de activiteit van de site overgenomen door Sébastien Schoonjans.' },
        ],
      },
    ],
  },

  mentions: {
    seoTitre: 'Wettelijke Vermeldingen',
    seoDescription:
      'Wettelijke vermeldingen van MirumGames: ondernemingsgegevens, eigenaar van de site, btw-nummer en contactgegevens.',
    titre: 'Wettelijke Vermeldingen',
    maj: 'Laatst bijgewerkt: 23/09/2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Gegevens van de Onderneming',
        blocs: [
          {
            encadre: encadreIdentite({
              nom: 'Naam van de onderneming',
              statut: 'Statuut',
              statutValeur: 'zelfstandig ondernemer (natuurlijke persoon)',
              adresse: 'Adres',
              pays: 'België',
              bce: 'Ondernemingsnummer (KBO)',
              tva: 'Btw-nummer',
              email: 'E-mail',
              telephone: 'Telefoon',
              sep: ':',
            }),
          },
        ],
      },
      {
        titre: 'Verantwoordelijke Uitgever',
        blocs: [
          { p: '<strong>Sébastien Schoonjans</strong><br />Verantwoordelijk voor de publicatie van MirumGames.com' },
        ],
      },
      {
        titre: 'Hosting van de Site',
        blocs: [
          { p: 'MirumGames.com wordt gehost door:<br /><strong>Cloudflare Pages</strong> (publieke interface)<br /><strong>Dedicated server</strong> (applicatie en database)<br /><br />De gegevens worden binnen de Europese Unie gehost en verwerkt overeenkomstig de AVG.' },
        ],
      },
      {
        titre: 'Intellectuele Eigendom',
        blocs: [
          { p: 'De volledige inhoud van MirumGames.com (teksten, afbeeldingen, illustraties, logo\'s, video\'s, enz.) is beschermd door het intellectuele-eigendomsrecht.' },
          { p: 'Elke reproductie, weergave, wijziging, publicatie of aanpassing van het geheel of een deel van de site, op welke wijze dan ook, is verboden zonder voorafgaande schriftelijke toestemming van de uitgever van de site, Sébastien Schoonjans.' },
        ],
      },
      {
        titre: 'Belastingen en Heffingen',
        blocs: [
          { p: 'Wij wijzen u erop dat onze prijzen de in België geldende belastingen en heffingen omvatten. De wetgeving verschilt van land tot land.' },
          { p: 'De koper gaat na of in zijn land van verblijf andere belastingen of heffingen verschuldigd zijn en betaalt in voorkomend geval alle heffingen, belastingen en lasten van welke aard ook op de producten die hij in zijn land invoert.' },
        ],
      },
      {
        titre: 'Beperking van Aansprakelijkheid',
        blocs: [
          { p: 'De uitgever van de site streeft ernaar de hier gepubliceerde informatie juist en actueel te houden, en behoudt zich het recht voor de inhoud op elk moment en zonder voorafgaande kennisgeving te corrigeren.' },
          { p: 'De uitgever kan echter de juistheid, nauwkeurigheid of volledigheid van de op deze site beschikbaar gestelde informatie niet waarborgen.' },
        ],
      },
      {
        titre: 'Cookies en Persoonsgegevens',
        blocs: [
          { p: 'Voor alle informatie over het gebruik van cookies en de bescherming van uw persoonsgegevens raadpleegt u ons <a href="/privacy" class="text-blue-600 hover:text-blue-800 underline">Privacybeleid</a>.' },
        ],
      },
      {
        titre: 'Toepasselijk Recht',
        blocs: [
          { p: 'Deze wettelijke vermeldingen worden beheerst door het Belgische recht. Bij een geschil richt de consument zich in eerste instantie tot MirumGames.com om een minnelijke oplossing te vinden.' },
          { p: 'Bij gebreke daarvan wordt het geschil voorgelegd aan de uitsluitende bevoegdheid van de bevoegde Belgische rechtbanken.' },
        ],
      },
      {
        titre: 'Contact',
        blocs: [
          { p: `Voor elke vraag over deze wettelijke vermeldingen kunt u ons bereiken op:<br /><strong>E-mail:</strong> ${COURRIEL}<br /><strong>Adres:</strong> ${ADRESSE}<br /><strong>Telefoon:</strong> ${TELEPHONE}` },
        ],
      },
    ],
  },

  paiement: {
    seoTitre: 'Veilig Betalen',
    seoDescription:
      'Veilig betalen bij MirumGames: transacties via Stripe, SSL/TLS-versleuteling, PCI-DSS-certificering en praktische tips.',
    titre: 'Veilig Betalen',
    maj: 'Laatst bijgewerkt: 18/02/2024',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Betalen via STRIPE',
        blocs: [
          { p: 'De beveiliging van bankverrichtingen is van het grootste belang. MirumGames.com doet daarvoor een beroep op de expertise van STRIPE om uw betalingen maximaal te beveiligen.' },
        ],
      },
      {
        titre: 'Is betalen bij MirumGames veilig?',
        blocs: [
          { p: 'Ja. Tijdens de betaalfase verloopt de volledige transactie versleuteld via STRIPE. U verlaat MirumGames.com even en volledig transparant om uw bankgegevens in te voeren.' },
          { p: 'Dat waarborgt dat:' },
          {
            liste: [
              'MirumGames.com uw kaartnummer nooit te zien krijgt en geen toegang heeft tot uw bankgegevens',
              'MirumGames.com de details van uw transacties niet kent — alleen het totaalbedrag en het bestelnummer worden aan ons doorgegeven',
              'Uw bankgegevens uitsluitend door STRIPE worden verwerkt, een gecertificeerde en betrouwbare dienstverlener',
            ],
          },
        ],
      },
      {
        titre: 'Welke beveiligingsmaatregelen neemt STRIPE?',
        blocs: [
          { p: 'STRIPE gebruikt het gestandaardiseerde versleutelingssysteem dat bekendstaat als het „SSL-protocol” (Secure Sockets Layer).' },
          { p: 'Controleer op de betaalpagina deze beveiligingsindicatoren:' },
          {
            liste: [
              '<strong>Beveiligingspictogram:</strong> in de hoek van uw browser hoort een gesloten hangslot te staan',
              '<strong>Adresbalk:</strong> de URL moet beginnen met „https://” (en niet „http://”)',
              'De „s” van https wijst op een beveiligde, versleutelde verbinding',
            ],
          },
          { p: 'Ziet u een waarschuwing, dan schakelt u over van een versleutelde naar een onversleutelde modus (of omgekeerd). Controleer dat dan vóór u vertrouwelijke gegevens invoert.' },
        ],
      },
      {
        titre: 'Certificeringen van STRIPE',
        blocs: [
          { p: 'STRIPE voldoet aan de strengste normen:' },
          {
            liste: [
              '<strong>PCI-DSS</strong> (Payment Card Industry Data Security Standard): de hoogste beveiligingscertificering voor kaartbetalingen',
              '<strong>AVG</strong>: volledige naleving van de Europese regelgeving',
              '<strong>ISO 27001</strong>: certificering voor het beheer van informatiebeveiliging',
              '<strong>SOC 2 Type II</strong>: onafhankelijke beveiligings- en nalevingsaudit',
            ],
          },
        ],
      },
      {
        titre: 'Beveiligingsadvies',
        blocs: [
          { p: 'Om veilig te betalen:' },
          {
            liste: [
              '✓ Gebruik altijd de recentste versie van uw browser',
              '✓ Betaal alleen via beveiligde verbindingen (niet op onbeveiligde openbare wifi)',
              '✓ Controleer altijd of het hangslot gesloten is en de URL met „https://” begint',
              '✓ Deel uw betaalgegevens nooit per e-mail of telefoon',
              '✓ Controleer uw rekeninguittreksel regelmatig op verdachte verrichtingen',
            ],
          },
        ],
      },
      {
        titre: 'Wat gebeurt er na de betaling?',
        blocs: [
          { p: 'Zodra de betaling is goedgekeurd:' },
          {
            liste: [
              'U ontvangt een bestelbevestiging per e-mail',
              'MirumGames.com ontvangt alleen het totaalbedrag en uw bestelnummer',
              'STRIPE bewaart uw betaalgegevens op een beveiligde manier',
              'Uw bestelling wordt klaargemaakt en verzonden',
            ],
          },
        ],
      },
      {
        titre: 'Bij een probleem',
        blocs: [
          { p: 'Merkt u verdachte activiteit op uw rekening?' },
          {
            liste: [
              'Neem onmiddellijk contact op met uw bank',
              `Stuur een e-mail naar ${COURRIEL} met de details van het probleem`,
              'Meld het probleem rechtstreeks aan STRIPE',
            ],
          },
        ],
      },
      {
        titre: 'Veelgestelde vragen',
        blocs: [
          { p: '<strong>V: Bewaart MirumGames.com mijn kaartgegevens?</strong><br />A: Nee, absoluut niet. Alleen STRIPE beheert uw bankgegevens.' },
          { p: `<strong>V: Hoe kan ik mijn betaalgegevens laten verwijderen?</strong><br />A: Neem contact op via ${COURRIEL} om de verwijdering van uw gegevens te vragen.` },
          { p: '<strong>V: Kan ik meerdere betaalmethoden gebruiken?</strong><br />A: Ja. STRIPE aanvaardt kredietkaarten, debetkaarten en andere methoden, afhankelijk van uw locatie.' },
        ],
      },
      {
        titre: 'Meer informatie',
        blocs: [
          { p: 'Meer details over de beveiliging bij STRIPE vindt u op: <a href="https://stripe.com/security" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">stripe.com/security</a>' },
        ],
      },
    ],
  },
};
